import isDevelopment from "../Helpers/isDevelopment";
const baseURL = isDevelopment
  ? "http://localhost:8080"
  : "https://server.yerson.com";
export default baseURL;
